import { BUYER, TRADE_IN, VEHICLE_ENTITY } from '@makemydeal/dr-shared-types';

import type { FsEntity } from './useFsEntitySlideout';
import { FS_FEES_ENTITY, FS_PROTECTION_ENTITY, FS_RATE_ENTITY, FS_TAXES_ENTITY, FS_UNROUTED_ENTITY } from './useFsEntitySlideout';

export type FsFieldLabel = {
    label: string;
    entity: FsEntity;
    location: string;
};

const CUSTOMER_INFO_PERSONAL = 'Customer Info › Personal Information';
const CUSTOMER_INFO_ADDITIONAL = 'Customer Info › Additional Information';
const CUSTOMER_INFO_PHONES = 'Customer Info › Phone Numbers';
const DEAL_BREAKDOWN = 'Deal breakdown';
const TRADES = 'Trades';
const TAXES = 'Taxes';
const PROTECTION_PRODUCTS = 'Protection Products';
const FEES = 'Fees';

export const FS_FIELD_LABEL_MAP: Record<string, FsFieldLabel> = {
    dateofbirth: { label: 'Date of Birth', entity: BUYER, location: CUSTOMER_INFO_ADDITIONAL },
    ssn: { label: 'Social Security Number', entity: BUYER, location: CUSTOMER_INFO_ADDITIONAL },
    taxid: { label: 'Tax ID Number', entity: BUYER, location: CUSTOMER_INFO_ADDITIONAL },
    checkingaccount: { label: 'Checking Account Number', entity: BUYER, location: CUSTOMER_INFO_ADDITIONAL },
    driverslicensenumber: { label: "Driver's License Number", entity: BUYER, location: CUSTOMER_INFO_ADDITIONAL },
    driverslicensestate: { label: "Driver's License State", entity: BUYER, location: CUSTOMER_INFO_ADDITIONAL },
    firstname: { label: 'Legal First Name', entity: BUYER, location: CUSTOMER_INFO_PERSONAL },
    lastname: { label: 'Legal Last Name', entity: BUYER, location: CUSTOMER_INFO_PERSONAL },
    otherphone: { label: 'Cell Phone', entity: BUYER, location: CUSTOMER_INFO_PHONES },
    phone: { label: 'Home Phone', entity: BUYER, location: CUSTOMER_INFO_PHONES },
    email: { label: 'Email Address', entity: BUYER, location: CUSTOMER_INFO_PERSONAL },

    stocknumber: { label: 'Stock Number', entity: VEHICLE_ENTITY, location: 'Vehicle' },
    vin: { label: 'VIN', entity: VEHICLE_ENTITY, location: 'Vehicle' },

    othertrim: { label: 'Trim', entity: TRADE_IN, location: TRADES },
    lienholdername: { label: 'Lienholder', entity: TRADE_IN, location: 'Trades › Lienholder Information' },
    nettrade: { label: 'Net Trade', entity: TRADE_IN, location: DEAL_BREAKDOWN },

    gap: { label: 'GAP', entity: FS_PROTECTION_ENTITY, location: PROTECTION_PRODUCTS },
    warranty: { label: 'Service Contract', entity: FS_PROTECTION_ENTITY, location: PROTECTION_PRODUCTS },
    creditlifeins: { label: 'Credit Life', entity: FS_PROTECTION_ENTITY, location: PROTECTION_PRODUCTS },
    accidenthealthins: { label: 'Accident & Health', entity: FS_PROTECTION_ENTITY, location: PROTECTION_PRODUCTS },

    acquisitionfees: { label: 'Acquisition Fee', entity: FS_FEES_ENTITY, location: FEES },
    governmentfees: { label: 'Government Fees', entity: FS_FEES_ENTITY, location: FEES },

    requestedapr: { label: 'Rate', entity: FS_RATE_ENTITY, location: 'Rate' },
    msrp: { label: 'MSRP', entity: FS_UNROUTED_ENTITY, location: DEAL_BREAKDOWN },
    term: { label: 'Term (Monthly)', entity: FS_UNROUTED_ENTITY, location: DEAL_BREAKDOWN },
    vehiclesellingprice: { label: 'Selling Price', entity: FS_UNROUTED_ENTITY, location: DEAL_BREAKDOWN },
    salestax: { label: 'Taxes', entity: FS_TAXES_ENTITY, location: TAXES }
};

export const resolveFsFieldLabel = (canonicalField: string): FsFieldLabel | undefined => FS_FIELD_LABEL_MAP[canonicalField];
